export default "__VITE_ASSET__CgJSFO34__"